export const EOLConfirmationPopup = {
  title: "Test in progress. Are you sure you want to navigate ?",
  className: "navigate-confirm-popup",
};

export const WithoutOrganisationPopup = {
  title: "No Access to any Organization",
  content: <>Please contact Admin to add you to an Organisation.</>,
  okText: "Logout",
  width: 480,
  className: "no-org-modal",
};
